/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect, useState,
} from 'react';
import moment from 'moment';
import {
  makeStyles, TableContainer, Table, TableBody, TableCell, TableRow, Grid, Divider,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import { connect, useDispatch } from 'react-redux';
import { GET_HISTORY_CONSUMPTION_DASHBOARD, GET_REQUEST_DASHBOARD, CLEAR_SERVICES_DATA_DASHBOARD } from '../../../types/license.type';
import CustomTable from '../../../components/form/Table/CustomTable';
import { getContractDetailsAction } from '../../../actions/license.action';
import ArrowBackMovements from '../../../assets/img/iconos/license/ArrowBackMovements.svg';

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  title: {
    ...theme.backOffice.configurations.title,
    fontWeight: 700,
    fontSize: '31px',
    paddingTop: '6px',
    paddingLeft: '20px',
  },
  paperGroup: {
    backgroundColor: '#fff',
    margin: 20,
    borderRadius: 10,
    border: '1px solid #32ACDE',
    padding: 20,
    minHeight: 300,
  },
  icon: {
    ...theme.backOffice.configurations.title,
    fontWeight: 700,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '27px',
    paddingLeft: '20px',
  },
  table: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  tableCellHead: {
    height: '58.28px',
    fontWeight: 'bold',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
    '&:last-child': {
      borderTopRightRadius: '10px',
      borderBottomRightRadius: '10px',
    },
    ...theme.miplan.tablePlanTable,
  },
  paperStyle: {
    padding: '20px',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.2)',
  },
  highlightText: {
    color: '#009BDD',
    fontWeight: 700,
  },
  customTableWrapper: {
    width: '100%',
    paddingBottom: '30px',
    paddingRight: '30px',
    paddingLeft: '30px',
  },
  contractText: {
    color: '#293233',
    fontSize: '15px',
    fontWeight: 400,
  },
}));

/**
 * View Movements
 * @param {*} props
 * @returns
 */
const ContractInfo = (props) => {
  const {
    history, getContractDetails,
  } = props;
  const [dataClient, setDataClient] = useState({});
  const [serviceData, setServiceData] = useState([]);

  const classes = useStyles();
  const dispatch = useDispatch();
  const formatNumber = (number) => {
    const exp = /(\d)(?=(\d{3})+(?!\d))/g;
    const rep = '$1,';
    return number.toString().replace(exp, rep);
  };
  const formatDate = (date) => (
    date ? moment(date).format('DD/MM/YYYY') : ''
  );

  const onBack = () => {
    dispatch({
      type: GET_HISTORY_CONSUMPTION_DASHBOARD,
      payload: {},
    });
    dispatch({
      type: GET_REQUEST_DASHBOARD,
      payload: {},
    });
    dispatch({
      type: CLEAR_SERVICES_DATA_DASHBOARD,
      payload: {},
    });
    setDataClient({});
    history.push('/admin/dashboard');

  };

  useEffect(() => {
    if (Object.keys(getContractDetails).length > 0) {
      setDataClient({
        contractNumber: getContractDetails[0]?.contractNumber,
        cellphoneNumber: getContractDetails[0]?.customer?.cellphoneNumber,
        contractEndDate: formatDate(getContractDetails[0]?.customer?.contractEndDate),
        contractStartDate: formatDate(getContractDetails[0]?.customer?.contractStartDate),
        documentNumber: getContractDetails[0]?.customer?.documentNumber,
        documentType: getContractDetails[0]?.customer?.documentType,
        email: getContractDetails[0]?.customer?.email,
        name: getContractDetails[0]?.customer?.name,
        personType: getContractDetails[0]?.customer?.personType,
        serviceName: getContractDetails[0]?.customer?.serviceName,
      });
      const servicesData = getContractDetails[0]?.services?.map((service) => ({
        packageDescription: service.packageDescription,
        quantity: formatNumber(service.quantity),
        effectiveDate: formatDate(service.effectiveDate),
        expirationDate: formatDate(service.expirationDate),
        state: 0,
      })) || [];
      setServiceData(servicesData);
    }
  }, [getContractDetails]);

  const columnData = [
    {
      id: 'packageDescription',
      label: 'Servicios contratados',
      minWidth: 100,
      position: 1,
      sortPropertyName: 'packageDescription',
    },
    {
      id: 'quantity',
      label: 'Cantidad',
      minWidth: 100,
      position: 2,
      sortPropertyName: 'quantity',
    },
    {
      id: 'effectiveDate',
      label: 'Inicio vigencia',
      minWidth: 100,
      position: 3,
      sortPropertyName: 'effectiveDate',
    },
    {
      id: 'expirationDate',
      label: 'Fin vigencia',
      minWidth: 100,
      position: 4,
      sortPropertyName: 'expirationDate',
    },
  ];

  return (
    <>
      <Container component="main" maxWidth="lg">
        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.titleContainer}>
            <IconButton onClick={onBack}>
              <img src={ArrowBackMovements} alt="Back Icon" className={classes.icon} />
            </IconButton>
            <Typography
              color="primary"
              variant="h4"
              className={classes.title}
            >
              Detalle del contrato
            </Typography>
          </Box>
          <Paper elevation={3} className={classes.paperGroup}>
            <TableContainer>
              <Table
                stickyHeader
                className={classes.table}
                aria-labelledby="tableTitle"
                size="small"
                aria-label="customized table"
                style={{
                  tableLayout: 'fixed', paddingTop: '18px', paddingRight: '30px', paddingLeft: '30px', borderSpacing: '0 12px',
                }}
              >
                <TableBody>
                  <TableRow
                    role="checkbox"
                    colSpan={2}
                    style={{ borderBottom: 'none' }}
                  >
                    <TableCell className={classes.tableCellHead}>
                      <div style={{ display: 'flex', alignItems: 'center', fontSize: '18px' }}>
                        Número de oportunidad:&nbsp;
                        <Typography classes={{ body1: classes.columnStyleParent }} style={{ fontWeight: 200, fontSize: '18px' }}>
                          {dataClient?.contractNumber}
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ width: '100%', paddingBottom: '30px' }}>
              <Grid
                container
                alignItems="center"
                style={{
                  paddingTop: '18px',
                  paddingRight: '30px',
                  paddingLeft: '30px',
                  borderSpacing: '0px 12px',
                }}
              >
                <Grid item xs={12}>
                  <Paper className={classes.paperStyle}>
                    <Typography style={{ color: '#E55200', fontSize: '17px', fontWeight: 600 }}>
                      Información del cliente
                    </Typography>
                    <br />
                    <Typography className={classes.contractText}>
                      <Box display="flex" flexWrap="wrap">
                        <span style={{ marginRight: '25px' }}>
                          Tipo de documento:
                          {' '}
                          <span className={classes.highlightText}>{dataClient?.documentType}</span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Número de documento:
                          {' '}
                          <span className={classes.highlightText}>
                            {dataClient?.documentNumber}
                          </span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Nombre y Razon social:
                          {' '}
                          <span className={classes.highlightText}>{dataClient?.name}</span>
                        </span>
                      </Box>
                    </Typography>
                    <br />
                    <Typography component="div" className={classes.contractText}>
                      <Box display="flex" flexWrap="wrap">
                        <span style={{ marginRight: '25px' }}>
                          Tipo de persona:
                          {' '}
                          <span className={classes.highlightText}>{dataClient?.personType}</span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Telefono:
                          {' '}
                          <span className={classes.highlightText}>
                            {dataClient?.cellphoneNumber}
                          </span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Correo:
                          {' '}
                          <span className={classes.highlightText}>{dataClient?.email}</span>
                        </span>
                      </Box>
                    </Typography>
                    <br />
                    <Divider className={classes.divider} variant="fullWidth" />
                    <br />
                    <Typography component="div" className={classes.contractText}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          Producto:
                          {' '}
                          <span className={classes.highlightText}>
                            {dataClient?.serviceName}
                          </span>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          Inicio vigencia contrato:
                          {' '}
                          <span className={classes.highlightText}>
                            {dataClient?.contractStartDate}
                          </span>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          Fin vigencia contrato:
                          {' '}
                          <span className={classes.highlightText}>
                            {dataClient?.contractEndDate}
                          </span>
                        </Grid>
                      </Grid>
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </div>
            <div className={classes.customTableWrapper}>
              <CustomTable
                data={serviceData}
                columns={columnData}
                styleTableContainer={{ marginTop: '15px', width: 'auto' }}
                enablePagination={false}
                styleTableCell={{ textAlign: 'left' }}
                styleTableHead={{ textAlign: 'left' }}
              />
            </div>
          </Paper>
        </Paper>
      </Container>
    </>
  );
};

const mapStateToProps = (props) => ({
  getContractDetails: props.license.getContractDetails,
});

const mapDispatchToProps = {
  getContractDataDetails: getContractDetailsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractInfo);
